import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequest from '@libs/apiRequest';
import { setSnack } from 'utilities/redux.actions';
import * as actionTypes from './redux.actionTypes';
import * as actions from './redux.actions';

// Fetch my permissions
function* fetchMyPermissionsWorker() {
    try {
        const response = yield call(apiRequest, {
            url: 'permission/get/my-permissions',
            method: 'GET',
        });

        yield put(actions.fetchMyPermissionsSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchMyPermissionsFailure(error.message));
        yield put(
            setSnack({
                message: 'Failed to fetch permissions',
                type: 'error',
            })
        );
    }
}

// Watchers
export default function* () {
    yield takeLatest(actionTypes.FETCH_MY_PERMISSIONS, fetchMyPermissionsWorker);
}
